import { Button, CardContent, Stack, Typography } from '@mui/material'
import { useContext } from 'react'
import { Outlet } from 'react-router-dom'

import { AuthContext, TwilioConversationsProvider } from '../../providers'
import { AppProvider } from '../../providers/AppProvider/AppProvider'
import { PageNoAppbar } from '../Page/PageNoAppbar'

export default function RequireShop() {
  const { userShopId, logOut } = useContext(AuthContext)

  if (!userShopId) {
    return (
      <PageNoAppbar title="No Shop Found">
        <CardContent>
          <Stack spacing={3} alignItems="center">
            <Typography gutterBottom variant="h5">
              No Shop Found
            </Typography>
            <Typography maxWidth={'300px'} paragraph variant="body1">
              You have successfully logged in but your account is not associated
              with any shops.
            </Typography>
            <Typography maxWidth={'300px'} paragraph variant="body1">
              Please contact{' '}
              <a href="mailto:info@intuneauto.com">info@intuneauto.com</a> for
              assistance if you believe this is in error.
            </Typography>
            <Button fullWidth onClick={logOut} variant="outlined">
              Sign Out
            </Button>
          </Stack>
        </CardContent>
      </PageNoAppbar>
    )
  }

  return (
    <TwilioConversationsProvider>
      <AppProvider>
        <Outlet />
      </AppProvider>
    </TwilioConversationsProvider>
  )
}
